import axios from "axios";
import { getAuth } from "../providers/AppAuthProvider";

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';
const resource = "roles"
const resource_permissions = "permissions"

export async function get() {
  const url = `${baseUrl}/${resource}`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.get<any>(
    url,
    {
      headers,
    }
  );
}

export async function getAllPermissions() {
  const url = `${baseUrl}/${resource_permissions}`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.get<any>(
    url,
    {
      headers,
    }
  );
}
export async function getDetailRole(roleId: string) {
  const url = `${baseUrl}/${resource}/${roleId}`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.get<any>(
    url,
    {
      headers,
    }
  );
}

export async function assignPermissions(roleId: string, permissionIds: string[]) {
  const url = `${baseUrl}/${resource}/${roleId}/permissions`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.post<any>(
    url,
    {
      permissionIds: permissionIds,
    },
    {
      headers,
    }
  );
};


export async function create(params: any) {
  const url = `${baseUrl}/roles`

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.post<any>(
    url,
    {
      ...params,
    },
    {
      headers,
    }
  );
}

export async function update(id: string, params: any) {
  const url = `${baseUrl}/roles/${id}`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.put<any>(
    url,
    {
      ...params,
    },
    {
      headers,
    }
  );
}

export async function updateRole(id: string, name: string) {
  const url = `${baseUrl}/roles/${id}`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.put<any>(
    url,
    {
      "name": name
    },
    {
      headers,
    }
  );
}
